import React from "react";
import { ControlPanelTextField } from "./ControlPanelTextField";
import { ControlPanelCheckbox } from "./ControlPanelCheckbox";
import ControlPanelSelect from "./ControlPanelSelect";

export const ControlPanel = ({ options, rgbToHex, handleChange, hexToRgb }) => {
  const animationSpeedOptions = [
    { label: "Slow", value: "DEFAULT" },
    { label: "Medium", value: "MEDIUM" },
    { label: "Fast", value: "FAST" },
  ];

  const breathSpeedOptions = [
    { label: "Slow", value: "SLOW" },
    { label: "Medium", value: "MEDIUM" },
    { label: "Fast", value: "FAST" },
  ];

  return (
    <>
      <div>
        <ControlPanelCheckbox
          handleChange={handleChange}
          optionChecked={options.toggleAnimation}
          target="toggleAnimation"
          label="Toggle Animation"
        />
        <ControlPanelCheckbox
          handleChange={handleChange}
          optionChecked={options.toggleBreath}
          target="toggleBreath"
          label="Toggle Breath"
        />
      </div>

      <ControlPanelSelect
        value={options.aSpeed}
        onChange={(e) => handleChange("aSpeed", e.target.value)}
        label="Animation speed"
        options={animationSpeedOptions}
      />

      <ControlPanelSelect
        value={options.bSpeed}
        onChange={(e) => handleChange("bSpeed", e.target.value)}
        label="Breath Speed"
        options={breathSpeedOptions}
      />

      <ControlPanelTextField
        valueAction={rgbToHex(options.inrShapeColor)}
        handleChange={handleChange}
        target="inrShapeColor"
        label="Inner Shape Color"
        type="color"
        hexToRgb={hexToRgb}
      />

      <ControlPanelTextField
        valueAction={rgbToHex(options.extShapeColor)}
        handleChange={handleChange}
        target="extShapeColor"
        label="External Shape Color"
        type="color"
        hexToRgb={hexToRgb}
      />

      <ControlPanelTextField
        valueAction={options.title}
        handleChange={handleChange}
        target="title"
        label="Title"
        type="text"
      />

      <ControlPanelTextField
        valueAction={options.description}
        handleChange={handleChange}
        target="description"
        label="Description"
        type="text"
      />
    </>
  );
};
